function isInvalidValue(val: any) {
  return val === undefined || typeof val === 'function'
}

function isValidValue(val: any) {
  return !isInvalidValue(val)
}

export function makeKey(...args: any[]) {
  const key: string[] = []

  for (const arg of args) {
    if (typeof arg === 'function') {
      continue
    }

    if (Array.isArray(arg)) {
      key.push(
        `[${arg
          .filter(isValidValue)
          .map(x => makeKey(x))
          .join(',')}]`,
      )
      continue
    }

    if (arg instanceof Object) {
      const keys = Object.keys(arg).sort()
      const objectKeys = []
      for (const k of keys) {
        if (isInvalidValue(arg[k])) continue
        objectKeys.push(`"${k}":${makeKey(arg[k])}`)
      }

      key.push(`{${objectKeys.join(',')}}`)
      continue
    }

    if (typeof arg === 'string') {
      key.push(`"${arg}"`)
      continue
    }

    key.push(`${arg}`)
  }

  return key.join('_')
}
